import React, { useEffect, useState } from 'react';
import {
  Box, Button, FormControl, FormHelperText, InputLabel, MenuItem,
  Select, TextField, Typography, Paper, Table, TableHead, TableBody,
  TableRow, TableCell, IconButton, Menu, MenuItem as MUIMenuItem,
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  TableContainer, Collapse
} from '@mui/material';
import {
  MoreVert as MoreVertIcon, KeyboardArrowDown, KeyboardArrowUp
} from '@mui/icons-material';
import MainMeterSelector from './MainMeterSelector';
import SubMeterSelector from './SubMeterSelector';
import SiteService from './SiteService';
import ReadingRow from './ReadingRow';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function MeterReadingList() {
  const [mainMeterId, setMainMeterId] = useState();
  const [subMeterId, setSubMeterId] = useState('');
  const [dateFilter, setDateFilter] = useState({ operator: 'equals', date: [] });
  const [meterReadings, setMeterReadings] = useState([]);

  const handleSearch = () => {
    let [startDate, endDate] = [null, null];
    const d = dateFilter.date;
    switch (dateFilter.operator) {
      case 'equals': startDate = endDate = d[0]; break;
      case 'greater': startDate = d[0]; break;
      case 'less': endDate = d[0]; break;
      case 'between': [startDate, endDate] = d; break;
      default: break;
    }

    SiteService.getMeterReadings(mainMeterId, subMeterId, startDate, endDate)
      .then(res => setMeterReadings(res.data))
      .catch(err => { console.error(err); toast.error('Arama sırasında hata oluştu') });
  };

  return (
    <Box p={3}>
      <Typography variant="h5" align="center">Sayaç Okuma Listesi</Typography>

      <FormControl fullWidth margin="normal">
        <SubMeterSelector mainMeterId={mainMeterId} setMainMeterId={setMainMeterId} subMeterId={subMeterId} setSubMeterId={setSubMeterId} />
      </FormControl>

      <Box display="flex" alignItems="center" flexWrap="wrap" gap={2} mb={2}>
        <FormControl sx={{ minWidth: 120 }}>
          <InputLabel>Tarih Filtresi</InputLabel>
          <Select
            value={dateFilter.operator}
            onChange={e => setDateFilter({ ...dateFilter, operator: e.target.value, date: [] })}
            label="Tarih Filtresi"
          >
            <MenuItem value="equals">Eşittir</MenuItem>
            <MenuItem value="greater">Büyüktür</MenuItem>
            <MenuItem value="less">Küçüktür</MenuItem>
            <MenuItem value="between">Arasında</MenuItem>
          </Select>
        </FormControl>

        {dateFilter.operator === 'between' ? (
          <>
            <TextField type="date" onChange={e => setDateFilter(prev => ({ ...prev, date: [e.target.value, prev.date[1] || ''] }))} />
            <TextField type="date" onChange={e => setDateFilter(prev => ({ ...prev, date: [prev.date[0] || '', e.target.value] }))} />
          </>
        ) : (
          <TextField type="date" onChange={e => setDateFilter(prev => ({ ...prev, date: [e.target.value] }))} />
        )}

        <Button variant="contained" onClick={handleSearch}>Ara</Button>
      </Box>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Kod</TableCell>
              <TableCell>Adı</TableCell>
              <TableCell>Okuma Tarihi</TableCell>
              <TableCell>Okuma Tipi</TableCell>
              <TableCell align="right">İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {meterReadings.map(row => (
              <ReadingRow
                key={row.id}
                row={row}
                mainMeterId={mainMeterId}
                subMeterId={subMeterId}
                onDeleted={id => setMeterReadings(prev => prev.filter(r => r.id !== id))}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <ToastContainer position="top-right" autoClose={2000} />
    </Box>
  );
}
